import { controls } from "../../controls"
const ms222 = {
  label: "Standing Instruction",
  pageLabel: "Standing Instruction",
  starting: true,
  url: "ms222",
  formActions: { edit: { allow: true } },
  pageType: "history",
  formTabs: {
    allTabs: [

      {
        label: "Create",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", width: "col-sm-2", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", label: "Instruction No. From", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", placeHolder: "From", name: "instruction_no_from", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "To", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", placeHolder: "To", name: "instruction_no_to", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", default: true, name: "isInterest", label: "Interest", width: "col-sm-4" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "Due Date From", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "due_form_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "Due To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", isRequired: true, dateType: "ontype", name: "due_to_date", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", name: "isCancel", label: "Cancel", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", default: true, name: "isActive", label: "Active", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", tab: "create", label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      tab: "filter", beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ tab: "filter", data: "account_number_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", name: "isDebitFullBalance", label: "Debit Full Balance", width: "col-sm-4" }),
    ...controls.magicDateLabel({ tab: "filter", label: "Expiry Date From", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "expiry_form_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ tab: "filter", label: "To", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "expirt_date_to", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "# of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", placeHolder: "# of Records", name: "per_page", width: "col-sm-2" }),
  ],
  form: [
    {
      tab: "create",
      widths: "col-sm-12",
      subComponents: [
        ...controls.displayText({ tab: "create", label: "Parent Branch", star: true, width: "col-sm-2" }),
        ...controls.branch({ tab: "create", defaultValue: "assigned_branch", isRequired: true }),
        ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),
        // ...controls.displayText({tab:"create",width:"col-sm-6"}),
        ...controls.displayText({ tab: "create", label: "Instruction No.", width: "col-sm-2" }),
        ...controls.numberOnly({ tab: "create", placeHolder: "Instruction No", name: "instruction_no", width: "col-sm-2" }),
      ]
    },
    {
      tab: "create",
      widths: "col-sm-12",
      title: "Debit",
      subComponents: [
        ...controls.displayText({ tab: "create", width: "col-sm-1" }),
        ...controls.radio({ tab: "create", width: "col-sm-4", name: "debit_type", default: "product", cwidth: "col-sm-4", options: [{ label: "GL", value: "gl" }, { label: "Product", value: "product" }] }),

        ...controls.displayText({ tab: "create", width: "col-sm-7" }),

        ...controls.displayText({
          tab: "create", star: true, label: "GL Sub Head", width: "col-sm-2", parents: [
            {
              name: "debit_type",
              match: "in",
              value: ["product"],
            }],
        }),
        ...controls.product({
          tab: 'create', isReadOnly: 'edit', isRequired: true,
          name: "product_code_debit",
          displayData: { descn: "product_code_display_debit", guid: "product_code_guid_debit", glrefid: "product_code_debit" },
          parents: [
            {
              name: "debit_type",
              match: "in",
              value: ["product"],
            }]
        }),
        ...controls.showData({
          tab: "create", data: "product_code_display_debit", name: "product_code_display_debit", width: "col-sm-2", parents: [
            {
              name: "debit_type",
              match: "in",
              value: ["product"],
            }]
        }),

        ...controls.displayText({
          tab: "create", label: "General Ledger", width: "col-sm-2", parents: [
            {
              name: "debit_type",
              match: "in",
              value: ["gl"],
            }]
        }),
        ...controls.GL({
          tab: "create", name: "gl_debit", isRequired: true,
          displayData: { description: "gl_display_debit", guid: "gl_guid_debit", refacct: "gl_debit" },
          parents: [
            {
              name: "debit_type",
              match: "in",
              value: ["gl"],
            }]
        }),
        ...controls.showData({
          tab: "create", data: "gl_display_debit", name: "gl_display_debit",
          width: "col-sm-2", parents: [
            {
              name: "debit_type",
              match: "in",
              value: ["gl"],
            }]
        }),
        ...controls.displayText({ tab: "create", width: "col-sm-6" }),

        ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-2" }),
        ...controls.AccountNumber({
          tab: "create", beforeLeave: ["createAcNo"],
          name: "account_number_debit",
          displayData: {
            descn: "account_number_display_debit", guid: 'account_number_guid_debit', account_code: "account_number_debi"
          },
          parents: [
            {
              name: "debit_type",
              match: "in",
              value: ["product"],
              show: 'readonly'
            }
          ]
        }),
        ...controls.showData({ tab: "create", data: "account_number_display_debit", width: "col-sm-2" }),
        ...controls.displayText({ tab: "create", width: "col-sm-6" }),
        ...controls.displayText({ style: { textAlign: 'right' }, tab: "create", label: "Amount", width: "col-sm-2" }),
        ...controls.numtoword({
          tab: "create", convertedTo: "entered_amount_text_debit", name: "entered_amount_debit", width: "col-sm-2",
        }),
        ...controls.showData({
          tab: "create", data: "entered_amount_text_debit", name: "entered_amount_text_debit", width: "col-sm-8", style: { fontSize: 14 },
        }),
        ...controls.displayText({ tab: "create", width: "col-sm-1" }),
        ...controls.checkBox({ tab: "create", label: "Interest", name: "isInterest", width: "col-sm-2" }),
        ...controls.checkBox({ tab: "create", label: "Debit Full Balance", name: "isDebitFullBalance", width: "col-sm-4" })

      ]
    },
    {
      tab: "create",
      widths: "col-sm-12",
      title: "Credit No 1",
      subComponents: [
        ...controls.displayText({ tab: "create", width: "col-sm-1" }),
        ...controls.radio({ tab: "create", width: "col-sm-4", name: "credit_no_type1", default: "product", cwidth: "col-sm-4", options: [{ label: "GL", value: "gl" }, { label: "Product", value: "product" }] }),
        ...controls.displayText({
          tab: "create", width: "col-sm-7", parents: [
            {
              name: "credit_no_type1",
              match: "in",
              value: ["product"],
              // show: 'blank'
            }]
        }),
        ...controls.displayText({
          tab: "create", star: true, label: "GL Sub Head", width: "col-sm-2", parents: [
            {
              name: "credit_no_type1",
              match: "in",
              value: ["product"],
              // show: 'blank'
            }],
        }),
        ...controls.product({
          tab: 'create', isReadOnly: 'edit', isRequired: true,
          name: "product_code_credit1",
          displayData: { descn: "product_code_display_credit1", guid: "product_code_guid_credit1", glrefid: "product_code_credit1" },
          parents: [
            {
              name: "credit_no_type1",
              match: "in",
              value: ["product"],
              // show: 'blank'
            }]
        }),
        ...controls.showData({
          tab: "create", data: "product_code_display_credit1", name: "product_code_display_credit1", width: "col-sm-2", parents: [
            {
              name: "credit_no_type1",
              match: "in",
              value: ["product"],
              // show: 'blank'
            }]
        }),
        ...controls.displayText({
          tab: "create", width: "col-sm-7", parents: [
            {
              name: "credit_no_type1",
              match: "in",
              value: ["gl"],
              // show: 'blank'
            }]
        }),
        ...controls.displayText({
          tab: "create", star: true, label: "General Ledger", width: "col-sm-2", parents: [
            {
              name: "credit_no_type1",
              match: "in",
              value: ["gl"],
              // show: 'blank'
            }]
        }),
        ...controls.GL({
          tab: "create",
          name: "gl_credit1",
          displayData: { description: "gl_display_credit1", guid: "gl_guid_credit1", refacct: "gl_credit1" },
          parents: [
            {
              name: "credit_no_type1",
              match: "in",
              value: ["gl"],
              // show: 'blank'
            }]
        }),
        ...controls.showData({
          tab: "create", data: "gl_display_credit1", name: "gl_display_credit1", width: "col-sm-2", parents: [
            {
              name: "credit_no_type1",
              match: "in",
              value: ["gl"],
              // show: 'blank'
            }]
        }),
        ...controls.displayText({ tab: "create", width: "col-sm-6" }),
        ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-2" }),
        ...controls.AccountNumber({
          tab: "create", beforeLeave: ["createAcNo"],
          name: "account_number_credit1",
          displayData: {
            descn: "account_number_display_credit1", guid: 'account_number_guid_credit1'
          },
          parents: [
            {
              name: "credit_no_type1",
              match: "in",
              value: ["product"],
              show: 'readonly'
            }
          ]

        }),
        ...controls.showData({ tab: "create", data: "account_number_display_credit1", width: "col-sm-2" }),
        ...controls.displayText({ tab: "create", width: "col-sm-6" }),
        ...controls.displayText({ style: { textAlign: 'right' }, tab: "create", label: "Amount", width: "col-sm-2" }),
        ...controls.numtoword({
          tab: "create", convertedTo: "entered_amount_text_credit1", name: "entered_amount_credit1", width: "col-sm-2",
        }),
        ...controls.showData({
          tab: "filter", data: "entered_amount_text_credit1", name: "entered_amount_text_credit1", width: "col-sm-8", style: { fontSize: 14 },
        }),

      ]
    },
    {
      tab: "create",
      widths: "col-sm-12",
      title: "Credit No 2",
      subComponents: [
        ...controls.displayText({ tab: "create", width: "col-sm-1" }),
        ...controls.radio({ tab: "create", width: "col-sm-4", name: "credit_no_type2", cwidth: "col-sm-4", default: "product", options: [{ label: "GL", value: "gl" }, { label: "Product", value: "product", }] }),
        ...controls.displayText({
          tab: "create", width: "col-sm-7", parents: [
            {
              name: "credit_no_type2",
              match: "in",
              value: ["product"],

            }]
        }),
        ...controls.displayText({
          tab: "create", star: true, label: "GL Sub Head", width: "col-sm-2", parents: [
            {
              name: "credit_no_type2",
              match: "in",
              value: ["product"],

            }],
        }),
        ...controls.product({
          tab: 'create', isReadOnly: 'edit',
          name: "product_code_credit2",
          displayData: { descn: "product_code_display_credit2", guid: "product_code_guid_credit2", glrefid: "product_code_credit2" },
          parents: [
            {
              name: "credit_no_type2",
              match: "in",
              value: ["product"],

            }]
        }),
        ...controls.showData({
          tab: "create", data: "product_code_display_credit2", name: "product_code_display_credit2", width: "col-sm-2", parents: [
            {
              name: "credit_no_type2",
              match: "in",
              value: ["product"],

            }]
        }),
        ...controls.displayText({
          tab: "create", width: "col-sm-7", parents: [
            {
              name: "credit_no_type2",
              match: "in",
              value: ["gl"],

            }]
        }),
        ...controls.displayText({
          tab: "create", label: "General Ledger", width: "col-sm-2", parents: [
            {
              name: "credit_no_type2",
              match: "in",
              value: ["gl"],

            }]
        }),
        ...controls.GL({
          tab: "create",
          name: "gl_credit2",
          displayData: { description: "gl_display_credit2", guid: "gl_guid_credit2", refacct: "gl_credit2" },
          parents: [
            {
              name: "credit_no_type2",
              match: "in",
              value: ["gl"],

            }]
        }),
        ...controls.showData({
          tab: "create", data: "gl_display_credit2", name: "gl_display_credit2", width: "col-sm-2", parents: [
            {
              name: "credit_no_type2",
              match: "in",
              value: ["gl"],

            }]
        }),
        ...controls.displayText({ tab: "create", width: "col-sm-6" }),
        ...controls.displayText({ tab: "create", label: "Account No", width: "col-sm-2" }),
        ...controls.AccountNumber({
          tab: "create", beforeLeave: ["createAcNo"],
          name: "account_number_credit2",
          displayData: {
            descn: "account_number_display_credit2", guid: 'account_number_guid_credit2'
          },
          parents: [
            {
              name: "credit_no_type2",
              match: "in",
              value: ["product"],
              show: 'readonly'
            }
          ]

        }),
        ...controls.showData({ tab: "create", data: "account_number_display_credit2", width: "col-sm-2" }),
        ...controls.displayText({ tab: "create", width: "col-sm-6" }),
        ...controls.displayText({ style: { textAlign: 'right' }, tab: "create", label: "Amount", width: "col-sm-2" }),
        ...controls.numtoword({
          tab: "create", convertedTo: "entered_amount_text_credit2", name: "entered_amount_credit2", width: "col-sm-2",
        }),
        ...controls.showData({
          tab: "filter", data: "entered_amount_text_credit2", name: "entered_amount_text_credit2", width: "col-sm-8", style: { fontSize: 14 },
        }),

      ]
    },
    {
      tab: "create",
      widths: "col-sm-12",
      subComponents: [
        ...controls.magicDateLabel({ tab: "create", label: "Instr Given Date", width: "col-sm-2" }),
        ...controls.magicDate({
          tab: "create", dateType: "ontype", name: "instr_given_date",
          width: "col-sm-2", default: "sessiondate"
        }),
        ...controls.displayText({ tab: "create", width: "col-sm-8" }),
        ...controls.magicDateLabel({ tab: "create", label: "Execution Date", width: "col-sm-2" }),
        ...controls.magicDate({
          tab: "create", dateType: "ontype", name: "execution_date",
          width: "col-sm-2", default: "sessiondate", minDate: "today"
        }),
        ...controls.displayText({ tab: "create", width: "col-sm-8" }),
        ...controls.displayText({ tab: "create", width: "col-sm-2", label: "Instruction Period DD-MM" }),
        ...controls.numberOnly({ tab: "create", width: "col-sm-1", placeHolder: "DD", name: "instruction_days" }),
        ...controls.numberOnly({ tab: "create", width: "col-sm-1", placeHolder: "MM", name: "instruction_month" }),
        ...controls.displayText({ tab: "create", width: "col-sm-8" }),
        ...controls.magicDateLabel({ tab: "create", label: "Expiry Date", width: "col-sm-2" }),
        ...controls.magicDate({ tab: "create", dateType: "ontype", name: "expiry_date", width: "col-sm-2" }),
        ...controls.displayText({ tab: "create", width: "col-sm-8" }),
        ...controls.magicDateLabel({ tab: "create", label: "cancel Date", width: "col-sm-2" }),
        ...controls.magicDate({
          tab: "create", dateType: "ontype", name: "cancel_date",
          width: "col-sm-2"
        })

      ]

    }
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Branch",
        accessor: "branch_guid",
        width: 150
      },
      {
        Header: "Instr No",
        accessor: "instruction_no",
        width: 150
      },
      {
        Header: "Due Date",
        accessor: "due_date"
      },
      {
        Header: "Debit GL",
        accessor: "product_code_debit"
      },
      {
        Header: "Debit GL Name",
        accessor: "product_code_display_debit"
      },
      {
        Header: "Debit A/c No",
        accessor: "account_number_debit"
      },
      {
        Header: "Debit A/c Name",
        accessor: "account_number_display_debit"
      },
      {
        Header: "Debit Amount",
        accessor: "entered_amount_debit"
      },
      {
        Header: "Int YN",
        accessor: "isInterest"
      }, {
        Header: "Credit GL",
        accessor: "gl_display_credit1"
      }
    ]
  }
};

export default ms222;
